import React, { createRef } from 'react';
import { IonSegment, IonSegmentButton, IonButton, IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonModal } from '@ionic/react';
import '../styles/Statistics.scss';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import ReactCardFlip from 'react-card-flip';
import Utilities from '../Utilities';
import { folder, star, grid, eye, pricetag, fileTrayFull, albums, close, notifications, school, create, image } from 'ionicons/icons'
import Chart from './Chart';

class History extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            history: [],
            scheduled: [],
            completed: [],
            section: "history",
            showMax: 100,
        }
        this.load();
    }

    async load() {

        let history = [];
        let scheduled = [];
        let completed = [];

        let cards = await SQLStorage.getCards();

        for (let i = 0; i < cards.length; i++) {

            const card = cards[i];
            
            if (card.reviewAfter) {
                scheduled.push(card)
            }

            if (card.revisionCycle === 100) {
                completed.push(card)
            }

            card.history.map(item => {
                
                const happening = item.split("_");
                
                history.push({
                    card: card,
                    action: happening[0],
                    res: happening[1],
                    date: happening[2],
                })

                return item;

            })

        }

        console.log(history);

        history = history.sort((a, b) => {
            return a.date < b.date ? -1 : 1
        });

        this.setState({
            history: history,
            scheduled: scheduled,
            completed: completed,
        })

    }

    render() {
        return (
            <IonModal
                data-page="history" 
                ref={this.pageRef}
                isOpen={this.props.open}
                swipeToClose={true}
                onDidDismiss={() => {
                    this.props.onDidDismiss();
                }}
            >
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>History</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={() => { this.props.onDidDismiss() }}>
                                <IonIcon style={{ fontSize: 10, width: 24, color: "#555" }} slot="icon-only" icon={close} />
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonSegment onIonChange={e => this.setState({ section: e.detail.value })}>
                        <IonSegmentButton value="history">
                            <IonLabel>History</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="scheduled">
                            <IonLabel>Schedueld</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="completed">
                            <IonLabel>Compelted</IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                    { (this.state.section === "scheduled") &&
                       <div className="list" style={{ marginBottom: 32 }}>
                            { this.state.scheduled.map(item => {
                                return (
                                    <div style={{ color: 'white', borderBottom: '1px solid white', marginBottom: 16 }}>
                                            <p>{item.term} - {item.definition}</p>
                                            <p>Rev Cycle: {item.revisionCycle}</p>
                                            <p>Scheduled for {Utilities.formatDate(new Date(item.reviewAfter*1000), "DD/MM/YYYY HH:MM")}</p>
                                            <p>Last reviewed {Utilities.formatDate(new Date(item.lastReviewed*1000), "DD/MM/YYYY HH:MM")}</p>
                                            <p>Review Count {item.reviewCount}</p>
                                            <p>Strength {item.strength}</p>
                                    </div>
                                )
                            }) }
                        </div>
                    }
                    { (this.state.section === "completed") &&
                       <div className="list" style={{ marginBottom: 32 }}>
                            { this.state.completed.map(item => {
                                return (
                                    <div style={{ color: 'white', borderBottom: '1px solid white', marginBottom: 16 }}>
                                            <p>{item.term} - {item.definition}</p>
                                            <p>Rev Cycle: {item.revisionCycle}</p>
                                            <p>Scheduled for {Utilities.formatDate(new Date(item.reviewAfter*1000), "DD/MM/YYYY HH:MM")}</p>
                                            <p>Last reviewed {Utilities.formatDate(new Date(item.lastReviewed*1000), "DD/MM/YYYY HH:MM")}</p>
                                            <p>Review Count {item.reviewCount}</p>
                                            <p>Strength {item.strength}</p>
                                    </div>
                                )
                            }) }
                        </div>
                    }
                    { (this.state.section === "history") &&
                        <div className="list" style={{ marginBottom: 32 }}>
                            { this.state.history.map(item => {

                                const actionCode = item.action
                                const actionData = item.res
                                const date = new Date(parseInt(item.date)*1000);

                                let text = "";
                                let color = "#555";
                                let icon = eye;

                                if (actionCode === "1" || actionCode === "2") {
                                    if (actionData.indexOf("strength-") !== -1) {
                                        text += "Strength " + ["New", "Studying", null, "Learnt", null, "Mastered"][parseInt(actionData.replace("strength-", ""))]
                                    } else if (actionData === "star") {
                                        text += "Star "
                                    } else if (actionData === "image") {
                                        text += "Image "
                                    } else {
                                        text += "Tag " + actionData // TO DO name
                                    }
                                    text += (actionCode === "1") ? " added" : " removed"
                                    icon = (actionData === "image") ? image : pricetag
                                    color = (actionCode === "1") ? "#2dce91" : "#fb5b5a"
                                } else if (actionCode === "10" || actionCode === "11") {
                                    text += "Reviewed from " + (actionCode === "10" ? "notification" : "flashcards")
                                    icon = actionCode === "10" ? notifications : albums
                                    color = actionCode === "10" ? "#7579e7" : "#4D80E4"
                                } else if (actionCode === "pronounce" || actionCode === "select" || actionCode === "type" || actionCode.indexOf("term") !== -1 || actionCode.indexOf("definition") !== -1) {
                                    // TO DO better text
                                    text += "Reviewed " + (actionData === "1" ? "successfully" : "unsuccessfully") + " by " + Utilities.capitalize(actionCode) + " practice";
                                    icon = school
                                    color = (actionData === "1") ? "#2dce91" : "#fb5b5a"
                                } else if (actionCode === "4") {
                                    text = "Term updated"
                                    icon = create
                                    color = "#ffa259"
                                } else if (actionCode === "5") {
                                    text = "Definition updated"
                                    icon = create
                                    color = "#ffa259"
                                } else {
                                    return null;
                                }

                                return (
                                    <div className="item" style={{ display: 'flex' }}>
                                        <div className="ci" style={{ backgroundColor: color }}> <IonIcon icon={icon} /> </div>
                                        <div className="meta">
                                            <h2 style={{ color: "white" }} >{Utilities.timeSince(date)} ({Utilities.formatDate(date, "DD/MM/YYYY HH:MM")})</h2>
                                            <p style={{ color: "white" }}>{text}</p>
                                            <p style={{ color: "white" }}>{ item.card.term } - { item.card.definition }</p>
                                        </div>
                                    </div>
                                )
                            }) }
                        </div>
                    }
                </IonContent>
            </IonModal>
        );
    }

};


export default withIonLifeCycle(History);
